import React from 'react';
import { Link } from 'react-router-dom';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';
import blogs from '../data/blogs';
import useSEO from '../hooks/useSEO';
import './BlogPage.css';

const ClockIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="13" height="13" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth="2">
    <circle cx="12" cy="12" r="10" />
    <polyline points="12 6 12 12 16 14" />
  </svg>
);

const ArticleIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="48" height="48" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth="1.5">
    <path strokeLinecap="round" strokeLinejoin="round" d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
  </svg>
);

const ArrowRight = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth="2.5">
    <path strokeLinecap="round" strokeLinejoin="round" d="M17 8l4 4m0 0l-4 4m4-4H3" />
  </svg>
);

const BlogPage = () => {
  useSEO({
    title: "Blog | Physiotherapy & Rehabilitation Equipment Insights - Prime Rehab Industries",
    description: "Read expert articles on physiotherapy and rehabilitation equipment, buying guides and industry insights from Prime Rehab Industries, Chennai.",
    canonical: "https://www.primerehabindustries.in/blog"
  });

  return (
    <div className="blog-page">
      <Navbar />

      {/* Banner */}
      <section className="blog-banner">
        <div className="blog-banner-inner">
          <span className="blog-banner-tag">Our Blog</span>
          <h1>Insights &amp; Expert Knowledge</h1>
          <p>
            Stay updated with the latest trends, tips, and best practices in physiotherapy
            and rehabilitation equipment.
          </p>
        </div>
      </section>

      {/* Blog Grid */}
      <section className="blog-grid-section">
        <div className="blog-grid">
          {blogs.length === 0 ? (
            <div className="blog-empty">
              <ArticleIcon />
              <p>No posts found.</p>
            </div>
          ) : (
            blogs.map((blog) => (
              <Link 
                to={`/blog/${blog.id}`} 
                className="blog-card-link" 
                key={blog.id}
              >
                <article className="blog-card" id={`blog-card-${blog.id}`}>
                    {/* Image / Placeholder */}
                    {blog.image ? (
                    <img className="blog-card-image" src={blog.image} alt={blog.title} />
                    ) : (
                    <div className="blog-card-img-placeholder" aria-hidden="true">
                        <ArticleIcon />
                    </div>
                    )}

                    <div className="blog-card-body">
                    {/* Meta */}
                    <div className="blog-card-meta">
                        <span className="blog-card-category">{blog.category}</span>
                        <span className="blog-card-dot" />
                        <span className="blog-card-date">{blog.date}</span>
                    </div>

                    {/* Title */}
                    <h2>{blog.title}</h2>

                    {/* Excerpt */}
                    <p>{blog.excerpt}</p>

                    {/* Footer */}
                    <div className="blog-card-footer">
                        <span className="blog-card-read-time">
                        <ClockIcon />
                        {blog.readTime}
                        </span>
                        <span className="blog-card-cta">
                        Read More <ArrowRight />
                        </span>
                    </div>
                    </div>
                </article>
              </Link>
            ))
          )}
        </div>
      </section>

      {/* CTA Strip */}
      <section className="blog-cta-strip">
        <div className="blog-cta-strip-inner">
          <h2>Have a Question? Talk to Our Experts</h2>
          <p>
            Our team is ready to help you choose the right rehabilitation equipment for
            your clinic or hospital.
          </p>
          <a href="/contact" className="blog-cta-btn" id="blog-contact-cta">
            Contact Us
          </a>
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default BlogPage;
